// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1R8fO","clinicsSelect":"TableHeading_clinicsSelect__3i3cG"};